import axios from 'axios'
import qs from 'qs'

export async function orderresetpassword(username, email) {
    const params = {
        "cmdtype": "orderresetpassword",
        "username": username,
        "email": email
    }
    let qsdata = qs.stringify(params)

    const res = await axios.post('forgotpwd', qsdata)
    return res
}

export async function singup(user, passwd, firstname, lastname, domain, usage, country, email,education,occupation) {
    const params = {
        "username": user,
        "passwd": passwd,
        "email": email,
        'firstname': firstname,
        'lastname': lastname,
        'domain': domain,
        'usage': usage,
        'country': country,
        'education':education,
        'occupation':occupation
    }
    let qsdata = qs.stringify(params)
    const res = await axios.post('signup', qsdata)
    return res
}

//向服务器请求，判断用户是否已经注册过,即存在同名用户
export async function checkusername(username)
{
    const params = {
        "username": username,
    }
    let qsdata = qs.stringify(params)

    const res = await axios.post('checkuser', qsdata)
    return res
}
export async function resetpassword(useruid, passwd) {
    const params = {
        "userid": useruid,
        "passwd": passwd
    }
    let qsdata = qs.stringify(params)

    const res = await axios.post('resetpasswd', qsdata)
    return res
}

export async function changepassword(oldpasswd,newpasswd)
{
    //修改密码需要登录后操作，用户名在服务端通过session获得
    const params = {
        "oldpasswd": oldpasswd,
        "newpasswd":newpasswd
    }
    let qsdata = qs.stringify(params)

    const res = await axios.post('changepasswd', qsdata)
    return res
}

export async function login(username, passwd) {
    const params = {
        "cmdtype": "login",
        "username": username,
        "passwd": passwd
    }
    let qsdata = qs.stringify(params)

    const res = await axios.post('login', qsdata)
    return res
}

export async function logout() {
    const params = {
        "cmdtype": "logout",
    }
    let qsdata = qs.stringify(params)
    console.log(qsdata)
    const res = await axios.post('logout', qsdata)
    return res
}

export async function getuserprofile() {
    const params = {
        "cmdtype": "userprofile",
    }
    let qsdata = qs.stringify(params)
    
    const res = await axios.post('userprofile', qsdata)
    return res
}

export async function changeprofile(params)
{
    let qsdata = qs.stringify(params)
    
    const res = await axios.post('changeprofile', qsdata)
    return res
}

